module.exports = __webpack_public_path__ + "assets/img/fourth_user_s.c332337a.svg";